import { NavLink } from "react-router-dom";
import { Pencil, ArrowRightLeft, ScanBarcode, User, Search } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

const tabs = [
  { to: "/", icon: Pencil, key: "history", end: true, testid: "tab-history" },
  { to: "/recs", icon: ArrowRightLeft, key: "recs", testid: "tab-recs" },
  { to: "/scan", icon: ScanBarcode, key: "scan", center: true, testid: "tab-scan" },
  { to: "/search", icon: Search, key: "search", testid: "tab-search" },
  { to: "/profile", icon: User, key: "profile", testid: "tab-profile" },
];

export const BottomNav = () => {
  const { t } = useI18n();
  return (
    <nav className="fixed bottom-[calc(env(safe-area-inset-bottom)+1.75rem)] left-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-[400px] bg-[#FBF8F2] rounded-[32px] flex justify-around items-center px-3 py-3 z-50 shadow-[0_12px_34px_rgba(60,50,35,0.18)]" data-testid="bottom-nav">
      {tabs.map((tab) => (
        <NavLink key={tab.to} to={tab.to} end={tab.end} data-testid={tab.testid}
          className="flex flex-col items-center gap-1 flex-1 min-w-0">
          {({ isActive }) => (
            tab.center ? (
              <span className={`w-14 h-14 rounded-full flex items-center justify-center shadow-[0_6px_16px_rgba(16,145,90,0.4)] transition-transform active:scale-95 ${isActive ? "bg-emerald-600" : "bg-emerald-500"}`}>
                <tab.icon className="w-6 h-6 text-white" strokeWidth={2.2} />
              </span>
            ) : (
              <>
                <tab.icon className={`w-6 h-6 transition-colors ${isActive ? "text-emerald-600" : "text-slate-500"}`} strokeWidth={isActive ? 2.4 : 2} />
                <span className={`text-[11px] font-medium truncate max-w-full ${isActive ? "text-emerald-600" : "text-slate-500"}`}>{t(`nav.${tab.key}`)}</span>
              </>
            )
          )}
        </NavLink>
      ))}
    </nav>
  );
};

export const AppShell = ({ children }) => (
  <div className="min-h-screen bg-[#F4F0EA] flex justify-center">
    <div className="w-full max-w-[430px] bg-[#F4F0EA] min-h-screen relative sm:border-x border-black/5">
      <div className="flex items-center gap-2 px-4 pt-3" data-testid="app-header">
        <img src="/logo-mark.png" alt="NutriScan" className="h-10 w-10 rounded-xl" />
        <span className="font-heading font-extrabold text-2xl text-slate-900 tracking-tight">NutriScan</span>
      </div>
      <div className="px-4 pt-2 pb-40 min-h-screen">{children}</div>
      <BottomNav />
    </div>
  </div>
);
